import { create } from 'zustand';
import { createCurrencySlice, CurrencySlice } from '@/features/shared/currency-slice';

export type CurrencyState = CurrencySlice;

/**
 * Holds the region the visitor is browsing from. There is no user-facing currency
 * picker any more and nothing is persisted: `RegionHydrator` seeds this once per
 * page load from `/api/geolocation`, which derives the currency from the Akamai
 * country header. Persisting it would let a stale choice outlive the visitor's
 * actual location (WTDEV-1708).
 */
export const useCurrencyStore = create<CurrencyState>()((...a) => ({
  ...createCurrencySlice(...a),
}));
